import { Page } from '@optools/components/layout/page';
import { authorizedRouteLoader } from '@optools/utils/auth/authorized-route-loader';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/overrides')({
  beforeLoad: authorizedRouteLoader('overrides'),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page
      links={[
        { label: 'Session', to: '/overrides/session' },
        { label: 'Playback', to: '/overrides/playback' },
      ]}
      title="Overrides"
    />
  );
}
